import React from 'react';
import { Section, SectionHeader } from './ui/Section';
import { Reveal } from './ui/Reveal';
import { Card } from './ui/Card';
import { DollarSign, Users, Activity, Globe, Shield } from 'lucide-react';
export function MissionSection() {
  return <Section id="summary" variant="charcoal" data-id="element-275">
      <SectionHeader title="Executive Summary" subtitle="Strategic Profile" data-id="element-276" />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-277">
        <div className="lg:col-span-7" data-id="element-278">
          <Reveal data-id="element-279">
            <p className="text-xl text-slate-300 leading-relaxed mb-8 font-light border-l-4 border-gold-500 pl-6" data-id="element-280">
              A retired Senior Executive Service (SES) Tier I & II leader with
              over three decades of high-stakes logistics, acquisition, and
              operational experience across the Department of Defense, Joint
              Staff, and Combatant Commands.
            </p>
            <p className="text-slate-400 leading-relaxed mb-6" data-id="element-281">
              Proven authority in enterprise modernization, governance, and
              crisis response, having directed multi-billion dollar portfolios
              and led global supply chain operations during some of the most
              critical challenges of the 21st century. Currently leveraging this
              deep expertise to drive strategic growth and sustainment solutions
              for defense industry partners.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-5 space-y-4" data-id="element-282">
          <Reveal delay={200} data-id="element-283">
            <div className="flex items-center gap-4 p-4 bg-navy-900 border border-white/5 rounded-sm" data-id="element-284">
              <DollarSign className="text-gold-500 w-6 h-6 flex-shrink-0" data-id="element-285" />
              <div data-id="element-286">
                <span className="block text-white font-bold text-lg" data-id="element-287">
                  $42B+
                </span>
                <span className="text-slate-400 text-sm" data-id="element-288">
                  Annual Operations Leadership
                </span>
              </div>
            </div>
          </Reveal>

          <Reveal delay={300} data-id="element-289">
            <div className="flex items-center gap-4 p-4 bg-navy-900 border border-white/5 rounded-sm" data-id="element-290">
              <Shield className="text-gold-500 w-6 h-6 flex-shrink-0" data-id="element-291" />
              <div data-id="element-292">
                <span className="block text-white font-bold text-lg" data-id="element-293">
                  $18B+
                </span>
                <span className="text-slate-400 text-sm" data-id="element-294">
                  Acquisition Portfolio Oversight
                </span>
              </div>
            </div>
          </Reveal>

          <Reveal delay={400} data-id="element-295">
            <div className="flex items-center gap-4 p-4 bg-navy-900 border border-white/5 rounded-sm" data-id="element-296">
              <Users className="text-gold-500 w-6 h-6 flex-shrink-0" data-id="element-297" />
              <div data-id="element-298">
                <span className="block text-white font-bold text-lg" data-id="element-299">
                  27,000+
                </span>
                <span className="text-slate-400 text-sm" data-id="element-300">
                  Personnel Enterprise Leadership
                </span>
              </div>
            </div>
          </Reveal>

          <Reveal delay={500} data-id="element-301">
            <div className="flex items-center gap-4 p-4 bg-navy-900 border border-white/5 rounded-sm" data-id="element-302">
              <Activity className="text-gold-500 w-6 h-6 flex-shrink-0" data-id="element-303" />
              <div data-id="element-304">
                <span className="block text-white font-bold text-lg" data-id="element-305">
                  Crisis Response
                </span>
                <span className="text-slate-400 text-sm" data-id="element-306">
                  COVID-19, Ebola, Hurricanes
                </span>
              </div>
            </div>
          </Reveal>

          <Reveal delay={600} data-id="element-307">
            <div className="flex items-center gap-4 p-4 bg-navy-900 border border-white/5 rounded-sm" data-id="element-308">
              <Globe className="text-gold-500 w-6 h-6 flex-shrink-0" data-id="element-309" />
              <div data-id="element-310">
                <span className="block text-white font-bold text-lg" data-id="element-311">
                  Modernization
                </span>
                <span className="text-slate-400 text-sm" data-id="element-312">
                  Enterprise Governance Expertise
                </span>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </Section>;
}